export default __webpack_public_path__ + "static/media/connection.a2bfc9e1.svg";